<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading||reportIsDownloading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 class="pa-5" v-if="reportIsDownloading">
            <h3 style="text-align: center">Generating PDF</h3>
            <p style="text-align: center">This may take several minutes</p>
        </v-flex>
        <v-flex xs12 v-if="!loading&&!reportIsDownloading">
            <div class="hkl-report-holder">
                <!--div class="page-height-test-base"></div-->
                <!--div class="page-height-test"></div>
                <div class="page-height-test-too"></div>
                                <div class="page-height-test"></div>
                <div class="page-height-test-too"></div>
                                <div class="page-height-test"></div>
                <div class="page-height-test-too"></div>                <div class="page-height-test"></div>
                <div class="page-height-test-too"></div-->

                <div class="page-height hide-non-print">
                    <div style="padding-top:40vh;padding-bottom:10vh;" v-html="comments.title">
                    </div>
                </div>

                <div class="page-height hide-non-print">
                    <div style="padding-top:10vh;padding-bottom: 10vh;" v-html="comments.cc">
                    </div>
                </div>

                <div class="page-height">
                <v-card-title class="primary white--text headline">
                    Energy Saving Targets
                </v-card-title>
                <v-layout row wrap class="primary pb-3" >
                    <v-flex xs6 class="pl-3 pr-3">
                        <div style="width:300px; margin-left: auto; margin-right: auto;">
                        <v-gauge style="transform: rotate(180deg)" :value="mainTarget.value" :maxValue="37" height="300" width="300" :options="mainGaugeOptions" gaugeValueClass="hidden"></v-gauge>
                        </div>
                    </v-flex>
                    <v-flex xs6 class="pa-3" style="page-break-inside: avoid !important;">
                            <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments['comment1']"></inline-editor>
                        <div style="padding-left: 10px; padding-right: 10px;">
                            <p>The cumulative energy reduction for {{textNumbers.currentYear}} as compared with the baseline year {{textNumbers.baselineYear}} is <strong>{{textNumbers.cer}}</strong>. Below is the overall performance of each building.</p>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="pa-2 pb-3">
                    <v-flex xs6 v-for="facilityTarget in facilityTargets" class="pa-2 pt-3">
                        <div class="primary darken-1 fill-height pa-3" style="min-height: 320px;">
                            <h3 style="text-align: center">{{facilityTarget.name}} Energy Reduction {{facilityTarget.value}}% </h3>
                            <div style="width:240px; margin-left: auto; margin-right: auto;">
                                <v-gauge :style="'transform: rotate(36deg);'" :value="facilityTarget.value" :maxValue="50" :height="'240'" width="240" :options="gaugeOptions40" gaugeValueClass="hidden"></v-gauge>
                            </div>
                        </div>

                    </v-flex>
                </v-layout>
                </div>

                <div class="page-height">
                    <v-card-title class="primary white--text headline">
                        Energy Saving Short Term Target
                    </v-card-title>
                <v-layout row wrap class="primary">
                    <v-flex xs12 class="pa-3">
                         <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments.comment2"></inline-editor>
                    </v-flex>
                    <v-flex xs12 style="margin-top: 20px;">
                        <vue-plotly disable-responsive  v-if="chart1data" :data="chart1data" :layout="chart1layout" :options="{displayModeBar: false}"/>
                        <vue-plotly v-if="chart1table" :data="chart1table" :layout="{height:140,margin:{t:0,b:0}}" :options="{displayModeBar: false}"/>
                    </v-flex>
                    <v-flex xs12 class="pa-3">
                        <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments.comment3"></inline-editor>
                        <div style="padding-left: 10px; padding-right: 10px;">
                        <p>In {{textNumbers.currentMonth}} {{textNumbers.currentYear}}, the total energy consumption changed by {{textNumbers.abs_cms}} compared to {{textNumbers.previousYear}} which is equivalent to the Central Portfolio's electricity consumption of approximately {{textNumbers.abs_cmsEquiv}}. </p>
                        </div>
                    </v-flex>
                    <v-flex xs12  style="page-break-inside: avoid !important; margin-top: 20px;">
                        <vue-plotly disable-responsive  v-if="chart2data" :data="chart2data" :layout="chart2layout" :options="{displayModeBar: false}"/>
                        <vue-plotly v-if="chart1table" :data="chart2table" :layout="{height:100,margin:{t:0,b:0}}" :options="{displayModeBar: false}"/>
                    </v-flex>

                </v-layout>
                </div>
                <div class="page-height">
                    <v-layout row wrap class="primary">
                    <v-flex xs12 class="pa-3">
                        <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments.comment4"></inline-editor>
                    </v-flex>
                    <v-flex xs12  style="page-break-inside: avoid !important;">
                        <vue-plotly disable-responsive  v-if="chart3data" :data="chart3data" :layout="chart3layout" :options="{displayModeBar: false}"/>
                        <vue-plotly v-if="chart1table" :data="chart3table" :layout="{height:220,margin:{t:0,b:0}}" :options="{displayModeBar: false}"/>
                    </v-flex>
                    <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important;">
                        <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments.comment5"></inline-editor>
                    </v-flex>
                    <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important;">
                        <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments.comment6"></inline-editor>
                    </v-flex>
                    </v-layout>
                </div>
                <div class="page-height" v-if="REChartData">
                    <v-layout row wrap class="primary">
                    <v-flex xs12  style="page-break-inside: avoid !important;">
                        <vue-plotly disable-responsive  v-if="REChartData" :data="REChartData" :layout="REChartLayout" :options="{displayModeBar: false}"/>
                    </v-flex>
                    </v-layout>
                </div>
                <div style="page-break-before: always;" v-for="facility in facilityData" :class="[facility.extraChart1Data ? 'page-five-height':'page-four-height']">
                    <div class="page-height">
                    <v-card-title class="primary white--text headline">
                        {{facility.name}}
                    </v-card-title>
                    <v-layout row wrap>
                        <v-flex xs12 style="page-break-inside: avoid !important; margin-top: 30px;">
                            <vue-plotly v-if="facility.euGroupedData" disable-responsive :data="facility.euGroupedData" :layout="facility.euGroupedLayout" :options="{displayModeBar: false}"/>
                        </v-flex>
                        <v-flex xs6 style="page-break-inside: avoid !important; margin-top: 30px;">
                            <vue-plotly v-if="facility.eu2020StackData" disable-responsive :data="facility.eu2020StackData" :layout="facility.eu2020StackLayout" :options="{displayModeBar: false}"/>
                        </v-flex>
                        <v-flex xs6 style="page-break-inside: avoid !important; margin-top: 30px;">
                            <vue-plotly v-if="facility.eu2019StackData" disable-responsive :data="facility.eu2019StackData" :layout="facility.eu2019StackLayout" :options="{displayModeBar: false}"/>
                        </v-flex>
                        <v-flex xs12 style="margin-top: 40px;">
                            <vue-plotly v-if="facility.euTable" :data="facility.euTable" :layout="facility.euTableLayout" :options="{displayModeBar: false}"/>
                        </v-flex>
                        <v-flex xs12 style="margin-top: 10px;" v-if="facility.pvChartData">
                            <vue-plotly v-if="facility.pvChartData" :data="facility.pvChartData" :layout="facility.pvChartLayout" :options="{displayModeBar: false}"/>
                        </v-flex>
                    </v-layout>
                    </div>

                    <div style="page-break-before: always;" class="page-height">
                    <v-layout row wrap>
                        <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important; margin-top: 10px;">
                            The normalised electricity usage index (EUI) is shown as below. Note that the outdoor temperature is based on HKO monthly average weather data.
                        </v-flex>
                        <v-flex xs12 style="page-break-inside: avoid !important; margin-top: 20px;">
                            <vue-plotly v-if="facility.eiData" disable-responsive :data="facility.eiData" :layout="facility.eiLayout" :options="{displayModeBar: false}"/>
                        </v-flex>
                        <v-flex v-for="plot in facility.plotList" :key="'ms'+plot.id"  xs12 style="margin-top: 20px;">
                            <cop-plot v-if="plot.type==='cop'" ref="plots"
                                      :variable-x="plot.config['variable-x']"
                                      :variable-y="plot.config['variable-y']"
                                      :facility_name="facility_name"
                                      :date-range="plot.config['range']"
                                      :layout-overrides="plot.config['layout-overrides']"
                                      :extra-vars="plot.config['extra-vars']"
                                      :type="plot.config['type']"
                                      :mode="plot.config['mode']"
                                      :conversion-factor="0.28434517"
                                      just-plot
                            ></cop-plot>
                            <multi-plot-chart ref="plots" v-if="plot.type==='multi-chart'"
                                              :date-range="plot.config['range']"
                                              :variable-x="plot.config['variable-x']"
                                              :variables-list="plot.config['variables-list']"
                                              :layout-overrides="plot.config['layout-overrides']"
                                              :type="plot.config['type']"
                                              :x-scaling-factor="0.28434517"
                                              :options="{displayModeBar: false}"
                                              just-plot
                            ></multi-plot-chart>
                        </v-flex>
                        <v-flex xs12 style="page-break-inside: avoid !important; margin-bottom: 20px; margin-top: 60px;">
                            <vue-plotly v-if="facility.chillersOnData" disable-responsive :data="facility.chillersOnData" :layout="facility.chillersOnLayout" :options="{displayModeBar: false}"/>
                        </v-flex>
                        <v-flex xs12 class="pa-3" style="margin-top: 20px;">
                            <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments[facility.abbr].comment2"></inline-editor>
                        </v-flex>
                    </v-layout>
                    </div>


                    <div class="page-height" v-if="facility.extraChart1Data">
                        <v-layout row wrap>
                            <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important; margin-top: 10px;">
                                Since there may be difference in number of days and holidays on each month, we have extracted the average daily AC consumption & average hourly AC consumption from HKE meters:
                            </v-flex>
                            <v-flex xs12 v-if="facility.extraChart1Data" style="page-break-inside: avoid !important; margin-top: 80px;">
                                <vue-plotly  disable-responsive :data="facility.extraChart1Data" :layout="facility.extraChart1Layout" :options="{displayModeBar: false}"/>
                            </v-flex>
                            <v-flex xs12 v-if="facility.extraChart2Data" style="page-break-inside: avoid !important; margin-top: 80px;">
                                <vue-plotly  disable-responsive :data="facility.extraChart2Data" :layout="facility.extraChart2Layout" :options="{displayModeBar: false}"/>
                            </v-flex>
                            <v-flex xs12 class="pa-3" style="margin-top: 20px;">
                                <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments[facility.abbr].comment3"></inline-editor>
                        </v-flex>
                        </v-layout>
                    </div>
                    
                    <div class="page-height" v-if="facility.siteREChartData">
                        <v-layout row wrap>
                        <v-flex xs12 class="pa-3" style="page-break-inside: avoid !important; margin-top: 10px;" v-if="facility.siteREChartData">
                            <vue-plotly v-if="facility.siteREChartData" :data="facility.siteREChartData" :layout="facility.SiteREChartLayout" :options="{displayModeBar: false}"/>
                        </v-flex>
                        </v-layout>
                    </div>

                    <div class="page-two-height">
                    <v-layout row wrap>
                        <v-flex xs12 class="pa-3">
                            <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments[facility.abbr].comment1"></inline-editor>
                        </v-flex>
                    </v-layout>
                    </div>
                </div>
                <v-card-title class="primary white--text headline">
                    Additional Findings and Observations
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 class="pa-3">
                        <inline-editor :disabled="!$can('manage', 'executiveSummary')" v-model="comments.comment7"></inline-editor>
                    </v-flex>
                </v-layout>

            </div>

        </v-flex>
        <v-flex xs12 class="hide-print" v-if="!reportIsDownloading">
            <v-layout style="width: 900px; margin-left: auto; margin-right: auto;" >
                <v-spacer></v-spacer>
                <form action="https://asia-east2-pdm-229904.cloudfunctions.net/pdfconvert" method="post" ref="downloadform">
                    <input type="hidden" id="carnot" name="carnot" value="innovations"><br>
                    <input type="hidden" id="targetURL" name="targetURL" :value="targetURL"><br><br>
                    <!--input type="submit" value="Download"-->
                </form>
                <v-btn
                        v-if="!loading"
                        flat
                        @click="downloadReport()"
                >
                    <v-icon class="mr-2">fa-download</v-icon>
                    Download
                </v-btn>
                <v-btn
                        v-if="!loading"
                        flat
                        :disabled="!$can('manage', 'executiveSummary')"
                        @click="saveComments()"
                >
                    <v-icon class="mr-2">fa-save</v-icon>
                    Save Comments
                </v-btn>
                <v-btn flat :disabled="!$can('manage', 'executiveSummary')" @click="uploadDialogSwitch = true"><v-icon small class="mr-2">fa-file-excel</v-icon> Upload Data</v-btn>
                <v-btn flat :disabled="!$can('manage', 'executiveSummary')" v-if="!loading" @click="titledialog = true"><v-icon small class="mr-2">fa-edit</v-icon> Edit title and cc</v-btn>
                <maintenance-upload-dialog
                        v-model="uploadDialogSwitch"
                        v-if="uploadDialogSwitch"
                        endpoint="/customdataupload/"
                        cmcmode
                        title="Update Report">
                </maintenance-upload-dialog>
                <v-dialog v-model="titledialog" max-width="800">
                    <v-card>
                        <v-card-title class="primary white--text title">
                            Edit title and cc page
                        </v-card-title>
                        <v-card-text>
                            <inline-editor v-model="comments.title"></inline-editor>
                            <inline-editor v-model="comments.cc"></inline-editor>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat @click="titledialog=false">Done</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!--v-btn flat @click="loadComments()">Load comments</v-btn-->
            </v-layout>
        </v-flex>
    </v-layout>

</template>

<script>
    import VuePlotly from '@/components/VuePlotly'
    import {callAPI} from '@/helper'
    import moment from 'moment'
    import VGauge from 'vgauge';
    import InlineEditor from "../components/InlineEditor";
    import MultiPlotChart from "../components/MultiPlotChart"
    import CopPlot from "../components/CopPlot";
    import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";

    export default {
        name: 'ExecutiveSummary',
        components: {VuePlotly,InlineEditor,VGauge,MultiPlotChart,CopPlot,MaintenanceUploadDialog},
        computed:{
          targetURL () {
            let pass = localStorage.getItem('pass')
            //let url = "https://asia-east2-pdm-229904.cloudfunctions.net/function-1"
            //url = url + "?carnot=innovations&targetURL"+
            return "https://hkl-cmc.jec-digital.com/executive-summary?token="+pass
          }
        },
        data () {
            return {
                titledialog:false,
                uploadDialogSwitch:false,
                baseDate:  moment().subtract(8, "days"),
                endDate:  moment().subtract(1, "days"),
                textNumbers:{
                    currentYear:"2020",
                    currentMonth:"February",
                    previousYear:"2019",
                    baselineYear:"2008",
                    ter:"1.6%",
                    cms:"5.91%",
                    cmsEquiv:"727,318 kWh",
                    cer:"25.86%",
                },
                comments: {
                  comment1:"<p>With the approval from our CE in Feb 2020, " +
                    "we have set a new long-term target to reduce " +
                    "carbon emissions by 55% as compared with " +
                    "baseline level in 2008, which is equivalent to " +
                    "saving <strong>37%</strong> of energy (electricity) by <strong>2030</strong>.</p><p>" +
                    "In addition to the 2030 target, an interim " +
                    "target of <strong>32.3%</strong> of energy (electricity) " +
                    "reduction by 2025 is also set to gauge our " +
                    "continuous effort and progress.</p>",
                comment2:"<p>We aim to reduce energy (electricity) consumption " +
                    "for buildings in Central by 1.6% in 2020 as " +
                    "comparing to the level in 2019.</p>",
                comment3:"",
                comment4:"<p>The performance trend of cumulative performance of buildings is shown as follows</p> ",
                comment5:"<p>The graphs above indicate each complex/building’s 2020 whole year (January to December) " +
                    "energy saving performance compared to the same period of 2019.</p>",
                comment6:"<p>The graph below indicates the derivation of 2025 interim target against the 2030 target.</p>",
                comment7:"<p>On top of analysing energy consumption data for each month, we also look at the historical " +
                    "energy consumption data to predict trends and to scrutinize variation of data, thus to explain " +
                    "on the variation of data and to enhance our data credibility..</p>",
                    title:"<h1>Central Monitoring Centre</h1>\n" +
                        "                        <h2>Energy Performance Report for Central Portfolio</h2>",
                    cc:"<b>Distribution: </b>\n" +
                        "                        <ul>\n" +
                        "                            <li>Andy Yeung</li>\n" +
                        "                            <li>All Technical Managers</li>\n" +
                        "                            <li>All Property Managers</li>\n" +
                        "                        </ul>\n" +
                        "\n" +
                        "                        <b>Cc: </b>\n" +
                        "                        <ul>\n" +
                        "                            <li>Kenneth Foo</li>\n" +
                        "                            <li>Kendrew Leung</li>\n" +
                        "                        </ul>",
                  ES: {comment1: 'ES',comment2:"", comment3:""},
                  LM: {comment1: 'LM',comment2:"", comment3:""},
                  PB: {comment1: 'PB',comment2:"", comment3:""},
                  AX: {comment1: 'AH',comment2:"", comment3:""},
                  JH: {comment1: 'JH',comment2:"", comment3:""},
                  CH: {comment1: 'CH',comment2:"", comment3:""}
                },
                reportIsDownloading:false,
                mainGaugeOptions:{
                    angle: -0.5,
                    lineWidth: 0.2,
                    radiusScale: 0.9,
                    pointer: {
                        length: 0.6,
                        strokeWidth: 0.035,
                        color: '#606060'
                    },
                    limitMax: true,
                    limitMin: true,
                    highDpiSupport: true,
                    staticZones: [
                        {strokeStyle: "#f8bd00", min: 0, max: 2.9},
                        {strokeStyle: "#404040", min: 2.9, max: 3.1},
                        {strokeStyle: "#ffcf3b", min: 3.1, max: 5.9},
                        {strokeStyle: "#404040", min: 5.9, max: 6.1},
                        {strokeStyle: "#ffdb69", min: 6.1, max: 8.9},
                        {strokeStyle: "#404040", min: 8.9, max: 9.1},
                        {strokeStyle: "#fee392", min: 9.1, max: 11.9},
                        {strokeStyle: "#404040", min: 11.9, max: 12.1},
                        {strokeStyle: "#ffeeb9", min: 12.1, max: 14.9},
                        {strokeStyle: "#404040", min: 14.9, max: 15.1},
                        {strokeStyle: "#fef0cb", min: 15.1, max: 17.9},
                        {strokeStyle: "#404040", min: 17.9, max: 18.1},
                        {strokeStyle: "#c4dfb4", min: 18.1, max: 20.9},
                        {strokeStyle: "#404040", min: 20.9, max: 21.1},
                        {strokeStyle: "#a6cf8d", min: 21.1, max: 23.9},
                        {strokeStyle: "#404040", min: 23.9, max: 24.1},
                        {strokeStyle: "#90c371", min: 24.1, max: 26.9},
                        {strokeStyle: "#404040", min: 26.9, max: 27.1},
                        {strokeStyle: "#84bd61", min: 27.1, max: 29.9},
                        {strokeStyle: "#404040", min: 29.9, max: 30.1},
                        {strokeStyle: "#72b44a", min: 30.1, max: 32.2},
                        {strokeStyle: "#404040", min: 32.2, max: 32.4},
                        {strokeStyle: "#304a1e", min: 32.4, max: 36.8},
                        {strokeStyle: "#404040", min: 36.8, max: 37},
                    ],
                    staticLabels: {
                        font: "14px sans-serif",  // Specifies font
                        labels: [3,6,9,12,15,18,21,24,27,30,32.3,37],  // Print labels at these values
                        color: "#FFFFFF",  // Optional: Label text color
                        fractionDigits: 1  // Optional: Numerical precision. 0=round off.
                    }

                },
                gaugeOptions30:{
                    angle: -0.2,
                    lineWidth: 0.2,
                    radiusScale: 0.8,
                    pointer: {
                        length: 0.6,
                        strokeWidth: 0.035,
                        color: '#606060'
                    },
                    limitMax: true,
                    limitMin: true,
                    highDpiSupport: true,
                    staticZones: [
                        {strokeStyle: "#f8bd00", min: 0, max: 4.9},
                        {strokeStyle: "#404040", min: 4.9, max: 5.1},
                        {strokeStyle: "#ffd966", min: 5.1, max: 9.9},
                        {strokeStyle: "#404040", min: 9.9, max: 10.1},
                        {strokeStyle: "#fee598", min: 10.1, max: 14.9},
                        {strokeStyle: "#404040", min: 14.9, max: 15.1},
                        {strokeStyle: "#fef0cb", min: 15.1, max: 19.9},
                        {strokeStyle: "#404040", min: 19.9, max: 20.1},
                        {strokeStyle: "#bfddab", min: 20.1, max: 24.9},
                        {strokeStyle: "#404040", min: 24.9, max: 25.1},
                        {strokeStyle: "#8bc763", min: 25.1, max: 29.9},
                        {strokeStyle: "#404040", min: 29.9, max: 30.1},
                        {strokeStyle: "#6ca844", min: 30.1, max: 34.9},
                        {strokeStyle: "#404040", min: 34.9, max: 35.1},
                        {strokeStyle: "#538134", min: 35.1, max: 40},
                    ],
                    staticLabels: {
                        font: "14px sans-serif",  // Specifies font
                        labels: [0,5,10,15,20,25,30,35,40],  // Print labels at these values
                        color: "#FFFFFF",  // Optional: Label text color
                        fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                    }
                },
                gaugeOptions40:{
                    angle: -0.2,
                    lineWidth: 0.2,
                    radiusScale: 0.8,
                    pointer: {
                        length: 0.6,
                        strokeWidth: 0.035,
                        color: '#606060'
                    },
                    limitMax: true,
                    limitMin: true,
                    highDpiSupport: true,
                    staticZones: [
                        {strokeStyle: "#f8bd00", min: 0, max: 4.9},
                        {strokeStyle: "#404040", min: 4.9, max: 5.1},
                        {strokeStyle: "#ffd966", min: 5.1, max: 9.9},
                        {strokeStyle: "#404040", min: 9.9, max: 10.1},
                        {strokeStyle: "#fee598", min: 10.1, max: 14.9},
                        {strokeStyle: "#404040", min: 14.9, max: 15.1},
                        {strokeStyle: "#fef0cb", min: 15.1, max: 19.9},
                        {strokeStyle: "#404040", min: 19.9, max: 20.1},
                        {strokeStyle: "#bfddab", min: 20.1, max: 24.9},
                        {strokeStyle: "#404040", min: 24.9, max: 25.1},
                        {strokeStyle: "#8bc763", min: 25.1, max: 29.9},
                        {strokeStyle: "#404040", min: 29.9, max: 30.1},
                        {strokeStyle: "#6ca844", min: 30.1, max: 34.9},
                        {strokeStyle: "#404040", min: 34.9, max: 35.1},
                        {strokeStyle: "#538134", min: 35.1, max: 39.9},
                        {strokeStyle: "#404040", min: 39.9, max: 40.1},
                        {strokeStyle: "#538134", min: 40.1, max: 44.9},
                        {strokeStyle: "#404040", min: 44.9, max: 45.1},
                        {strokeStyle: "#538134", min: 45.1, max: 50},
                    ],
                    staticLabels: {
                        font: "14px sans-serif",  // Specifies font
                        labels: [0,5,10,15,20,25,30,35,40,45,50],  // Print labels at these values
                        color: "#FFFFFF",  // Optional: Label text color
                        fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                    }
                },
                loading:true,
                mainTarget:null,
                chart1data:null,
                chart1table:null,
                chart2data:null,
                facilityData:[],
                chart3data:null,
                chart4data:null,
                REChartData:null,
                chart1layout:null,
                chart2layout:null,
                chart3layout:null,
                chart4layout:null,
                REChartLayout:null,
                currentMonthName:"",
                facilityTargets:[],
                facilityList:{
                    "Exchange Square":{
                        endpoint:"https://es-production2-mrtzp2lq4q-df.a.run.app",
                        facilityName:"ES",
                        feBase:"https://hkl-es.jec-digital.com"
                    },
                    "Landmark":{
                        endpoint:"https://lm-production2-mrtzp2lq4q-df.a.run.app",
                        facilityName:"LM",
                        feBase:"https://hkl-lm.jec-digital.com"
                    },
                    "Chater House":{
                        endpoint:"https://ch-production2-mrtzp2lq4q-df.a.run.app",
                        facilityName:"CH",
                        feBase:"https://hkl-ch.jec-digital.com"
                    },
                    "Jardine House":{
                        endpoint:"https://jh-production2-mrtzp2lq4q-df.a.run.app",
                        facilityName:"JH",
                        feBase:"https://hkl-jh.jec-digital.com"
                    },
                    "Alexandra House":{
                        endpoint:"https://ax-production2-mrtzp2lq4q-df.a.run.app",
                        facilityName:"AX",
                        feBase:"https://hkl-ax.jec-digital.com"
                    },
                    "Prince's Building":{
                        endpoint:"https://pb-production2-mrtzp2lq4q-df.a.run.app",
                        facilityName:"PB",
                        feBase:"https://hkl-pb.jec-digital.com"
                    },
                },



            }
        },
        mounted(){
            this.loadData()
          this.loadComments()
        },
        methods:{
            printReport(){
                window.print()
            },
            downloadReport() {
                if(this.$can('manage','executiveSummary')){
                    this.saveComments()
                }
              this.$refs.downloadform.submit()
              this.reportIsDownloading=true
            },
            saveComments(){
              let me=this
              callAPI('result/',
                    {
                        'result_name':'hkl_cmc_comments',
                         'description': 'hkl_cmc_comments',
                      'facility_name': 'JEC',
                      'content': this.comments
                    },
                'put'
                ).then(function(result) {
                  //call snackbar
                me.$store.dispatch('callSnackbar', {text: 'Comments Saved.', to:null, active: true})

              })
            },

            loadComments() {
              let me=this
              callAPI('result/',
                    {
                      'result_name':'hkl_cmc_comments',
                      'facility_name': 'JEC'
                    },
                'post'
                ).then(function(result) {
                  //call snackbar
                me.$store.dispatch('callSnackbar', {text: 'Comments Loaded.', to:null, active: true})
                me.comments.comment1=result.data.result[0].content.comment1
                me.comments.comment2=result.data.result[0].content.comment2
                me.comments.comment3=result.data.result[0].content.comment3
                me.comments.comment4=result.data.result[0].content.comment4
                me.comments.comment5=result.data.result[0].content.comment5
                me.comments.comment6=result.data.result[0].content.comment6
                me.comments.comment7=result.data.result[0].content.comment7

                  if(result.data.result[0].content.title){
                      me.comments.title=result.data.result[0].content.title
                  }
                  if(result.data.result[0].content.cc){
                      me.comments.cc=result.data.result[0].content.cc
                  }

                me.comments.AX.comment1=result.data.result[0].content.AX.comment1
                me.comments.JH.comment1=result.data.result[0].content.JH.comment1
                me.comments.LM.comment1=result.data.result[0].content.LM.comment1
                me.comments.PB.comment1=result.data.result[0].content.PB.comment1
                me.comments.ES.comment1=result.data.result[0].content.ES.comment1
                me.comments.CH.comment1=result.data.result[0].content.CH.comment1

                  me.comments.AX.comment2=result.data.result[0].content.AX.comment2
                  me.comments.JH.comment2=result.data.result[0].content.JH.comment2
                  me.comments.LM.comment2=result.data.result[0].content.LM.comment2
                  me.comments.PB.comment2=result.data.result[0].content.PB.comment2
                  me.comments.ES.comment2=result.data.result[0].content.ES.comment2
                  me.comments.CH.comment2=result.data.result[0].content.CH.comment2

                  me.comments.AX.comment3=result.data.result[0].content.AX.comment3
                  me.comments.JH.comment3=result.data.result[0].content.JH.comment3
                  me.comments.LM.comment3=result.data.result[0].content.LM.comment3
                  me.comments.PB.comment3=result.data.result[0].content.PB.comment3
                  me.comments.ES.comment3=result.data.result[0].content.ES.comment3
                  me.comments.CH.comment3=result.data.result[0].content.CH.comment3

              })

            },
            loadData(){
                let me=this
                me.loading=true
                callAPI('customdata/',
                    {
                        'result_name':'hkl_cmc'
                    }
                ).then(function(customdata){
                    me.facilityTargets=customdata.data.facility_targets
                    me.mainTarget=customdata.data.main_target
                    let months=["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let monthsCut=months.slice(0,customdata.data.cec2020.length);
                    let increaseyby1month=_.get(me.$route.query, 'increaseyby1month', false) ? 1 : 0
                    let currentMonthIndex=customdata.data.cec2020.length-1+increaseyby1month
                    me.currentMonthName=months[currentMonthIndex]
                    let prefixer=currentMonthIndex+1>9 ? "" : "0"
                    me.baseDate = moment(customdata.data.textNumbers.currentYear.toString()+"-"+prefixer+(currentMonthIndex+1).toString()+"-01")
                    me.endDate = moment(customdata.data.textNumbers.currentYear.toString()+"-"+prefixer+(currentMonthIndex+1).toString()+"-01").add(1, "months")
                    let targetSaving=customdata.data.targetSaving;
                    let overallCP=customdata.data.overallCP;
                    let cec2020=customdata.data.cec2020;
                    let cec2019=customdata.data.cec2019;
                    let cecJH=customdata.data.cecSites.JH;
                    let cecCH=customdata.data.cecSites.CH;
                    let cecPB=customdata.data.cecSites.PB;
                    let cecAH=customdata.data.cecSites.AH;
                    let cecLM=customdata.data.cecSites.LM;
                    let cecES=customdata.data.cecSites.ES;
                    let energyReduction=[32.3,37];
                    let carbonReduction=[45,55];
                    let redYears=[2025,2030];
                    let chart1tableData=customdata.data.chart1_table;
                    let chart2tableData=customdata.data.chart2_table;
                    let chart3tableData=customdata.data.chart3_table;
                    if(customdata.data.REChartData && customdata.data.REChartData.length>0&&customdata.data.REChartDataYear.max_year&&customdata.data.REChartDataYear.min_year){
                        me.REChartData = customdata.data.REChartData
                        me.REChartLayout = {
                            height:360,
                            title:"HKL Central Portfolio Renewable Energy Total Generation "+ customdata.data.REChartDataYear.min_year + " - " + customdata.data.REChartDataYear.max_year,
                            margin:{
                                t:30,
                                b:50,
                            },
                            yaxis: {
                            title: 'Generated Energy (kWh)'
                            },
                            xaxis: {
                                tickangle: 45
                            },
                            legend: {
                            orientation: 'h',
                            x:0.5,
                            y:-0.3,
                            xanchor:'center'
                            },
                            barmode: 'stack'
                        }
                    } 
                    if(customdata.data.textNumbers){
                        me.textNumbers=customdata.data.textNumbers
                    }
                    me.chart1data=[
                        {
                            x:monthsCut,
                            y:overallCP,
                            name:"Overall (Central Portfolio)",
                            type: 'bar',
                        },{
                            x:months,
                            y:targetSaving,
                            name:"Target Saving",
                            type: 'lines',
                        },

                    ]
                    me.chart1table=[{
                        type: 'table',
                        header: {
                            values: ["","Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                            align: "center",
                            line: {width: 1, color: 'black'},
                            fill: {color: "grey"},
                            font: {family: "Arial", size: 12, color: "white"}
                        },
                        cells: {
                            values: chart1tableData,
                            align: "center",
                            line: {color: "black", width: 1},
                            font: {family: "Arial", size: 11, color: ["black"]}
                        }
                    }]
                    me.chart1layout={
                        height:360,
                        title:"Cumulative Energy Consumption Comparison for Central Portfolio ("+me.textNumbers.currentYear+" vs "+me.textNumbers.previousYear+")",
                        legend: {
                            orientation: 'h',
                            x:0.5,
                            y:-0.3,
                            xanchor:'center'
                        },
                        yaxis: {
                            title: 'Saving (%)'
                        },
                        margin:{
                            t:30,
                            b:20
                        }

                    }
                    me.chart2data=[
                        {
                            x:monthsCut,
                            y:cec2020,
                            name: me.textNumbers.currentYear,
                            type: 'bar',
                        },{
                            x:months,
                            y:cec2019,
                            name:me.textNumbers.previousYear,
                            type: 'lines',
                        },
                    ]
                    me.chart2table=[{
                        type: 'table',
                        header: {
                            values: ["","Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                            align: "center",
                            line: {width: 1, color: 'black'},
                            fill: {color: "grey"},
                            font: {family: "Arial", size: 12, color: "white"}
                        },
                        cells: {
                            values: chart2tableData,
                            align: "center",
                            line: {color: "black", width: 1},
                            font: {family: "Arial", size: 11, color: ["black"]}
                        }
                    }]
                    me.chart2layout={
                        title:"Cumulative Energy Consumption for Central Portfolio",
                        height:360,
                        legend: {
                            orientation: 'h',
                            x:0.5,
                            y:-0.3,
                            xanchor:'center'
                        },
                        yaxis: {
                            title: '(million kWh)'
                        },
                        margin:{
                            t:30,
                            b:20
                        }

                    }
                    me.chart3data=[
                        {
                            x:monthsCut,
                            y:cecJH,
                            name:"JH",
                            type: 'lines',
                        },{
                            x:monthsCut,
                            y:cecCH,
                            name:"CH",
                            type: 'lines',
                        },{
                            x:monthsCut,
                            y:cecPB,
                            name:"PB",
                            type: 'lines',
                        },{
                            x:monthsCut,
                            y:cecAH,
                            name:"AH",
                            type: 'lines',
                        },{
                            x:monthsCut,
                            y:cecLM,
                            name:"LM",
                            type: 'lines',
                        },{
                            x:monthsCut,
                            y:cecES,
                            name:"ES",
                            type: 'lines',
                        },
                        {
                            x:months,
                            y:targetSaving,
                            name:"Target Saving",
                            type: 'lines',
                        },
                    ]
                    me.chart3table=[{
                        type: 'table',
                        header: {
                            values: ["","Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                            align: "center",
                            line: {width: 1, color: 'black'},
                            fill: {color: "grey"},
                            font: {family: "Arial", size: 12, color: "white"}
                        },
                        cells: {
                            values: chart3tableData,
                            align: "center",
                            line: {color: "black", width: 1},
                            font: {family: "Arial", size: 11, color: ["black"]}
                        }
                    }]
                    me.chart3layout={
                        title:"Cumulative Energy Consumption Comparison" +
                            " for Individual Building/ Complex ("+me.textNumbers.currentYear+" vs "+me.textNumbers.previousYear+")",
                        legend: {
                            orientation: 'h',
                            x:0.5,
                            y:-0.3,
                            xanchor:'center'
                        },
                        yaxis: {
                            title: 'Saving (%)',
                        },
                        xaxis: {
                            showgrid:false,
                        },
                        margin:{
                            t:30,
                            b:20
                        },
                        height:360,
                    }
                    me.chart4data=[
                        {
                            x:redYears,
                            y:energyReduction,
                            name:"Energy Reduction",
                            type: 'lines',
                        },{
                            x:redYears,
                            y:carbonReduction,
                            name:"Carbon Reduction",
                            type: 'lines',
                        },
                    ]
                    me.chart4layout={
                        title:"2020-2030 Carbon vs. Energy Percentage Reduction",
                        legend: {
                            orientation: 'h',
                            x:0.5,
                            y:-0.3,
                            xanchor:'center'
                        },
                        yaxis: {
                            title: '(%)'
                        },
                        margin:{
                            t:30,
                            b:20
                        },
                        height:360,
                    }

                    let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                    let runtimePromises=[]
                    let facilityData={}
                    for (let facility in me.facilityList){
                        let apiBaseUrl=me.facilityList[facility].endpoint
                        runtimePromises.push(callAPI('data2/',
                            {
                                'filters': {
                                    'facility_name': me.facilityList[facility].facilityName,
                                    'equipment_type_regex': '^chiller',
                                    'sensor_names': ["on"],
                                    'date_range':currentRange,
                                },
                                "pipeline": [
                                    {"type": "agg", "agg": "D", "agg_op": "sum"}
                                ],
                                "apiBaseUrl":apiBaseUrl,
                                "mfTagFacility":facility
                            }
                        ))
                        facilityData[facility]={
                            name:facility,
                            abbr:me.facilityList[facility].facilityName

                        }
                    }
                    Promise.all(runtimePromises).then(function (reses) {
                        for (let res of reses) {
                            let facility = JSON.parse(res.config.data)["mfTagFacility"]
                            let pref= me.facilityList[facility].facilityName
                            if(pref==="AX"){
                                pref="AH"
                            }
                            let chillerNames=[]
                            let chillerOn=[]
                            for (let key in res.data) {
                                if(key!=="timestamp"&&res.data[key]&&res.data[key].length>0){
                                    let totalTime = res.data[key].reduce((sum, x) => sum + x,0)/4
                                    if (totalTime>0) {
                                      chillerNames.push(key.split(' - ')[0])
                                      chillerOn.push(totalTime)
                                    }
                                }
                            }

                            for (let key in res.data) {
                                if(key!=="timestamp"&&res.data[key]&&res.data[key].length>0){
                                    let totalTime = res.data[key].reduce((sum, x) => sum + x,0)/4
                                    if (totalTime==0) {
                                      chillerNames.push(key.split(' - ')[0])
                                      chillerOn.push(totalTime)
                                    }
                                }
                            }
                            facilityData[facility].chillersOnData=[{
                                type: 'pie',
                                hole: .7,
                                labels: chillerNames,
                                sort:false,
                                values: chillerOn
                            }]
                            facilityData[facility].chillersOnLayout={
                                title:pref+" CHILLER RUNNING HOURS ("+me.currentMonthName+" "+me.textNumbers.currentYear+")",
                                margin:{
                                    t:60,
                                    b:0
                                },
                                height:300,
                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:0,
                                    xanchor:'center'
                                },
                            }
                            facilityData[facility].plotList=[
                                {
                                    'id': 64446+me.facilityList[facility].facilityName,
                                    'type': 'multi-chart',
                                    'config': {
                                        'range':{start:currentRange[0],end:currentRange[1]},
                                        'layout-overrides': {
                                            "title": pref+" Chiller COP vs Cooling Load Ton ("+me.currentMonthName+" "+me.textNumbers.currentYear+")",
                                            xaxis: {
                                                title: "Cooling Load (Ton)"
                                            },
                                            yaxis: {title: 'COP'},
                                            hovermode: 'closest',
                                            margin:{
                                                t:30,
                                                b:20
                                            },
                                            height:360,
                                            legend: {
                                                orientation: 'h',
                                                x:0.5,
                                                y:-0.3,
                                                xanchor:'center'
                                            }
                                        },
                                        type: 'scatter',
                                        'variables-list':[
                                            ...chillerNames.map(equip=>{
                                                return ({
                                                    equipment_name: equip,
                                                    facility_name: me.facilityList[facility].facilityName,
                                                    name: "COP",
                                                    mode: "markers",
                                                    on_only:true,
                                                    variableX: "Cooling_Load",
                                                    opacity:0.7,
                                                    x_min_threshold:50,
                                                    y_min_threshold:1,
                                                    y_max_threshold:15,
                                                    add_smooth:true,
                                                    apiBaseUrl:me.facilityList[facility].endpoint,
                                                    smooth_options: {span: 1.10, band: 0.99, degree: 2}
                                                })
                                            })],

                                    }
                                },
                            ]
                            facilityData[facility].eiData=customdata.data.monthly_energy_performance_by_site[pref].eiData
                            facilityData[facility].eiLayout={
                                title:pref+" - Year "+me.textNumbers.previousYear+", "+me.textNumbers.currentYear+" Electricity Index (MVAC) vs Temp",
                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:-0.3,
                                    xanchor:'center'
                                },
                                annotations: [
                                    {
                                        x: customdata.data.monthly_energy_performance_by_site[pref].eiData[0]["x"][currentMonthIndex],
                                        y: customdata.data.monthly_energy_performance_by_site[pref].eiData[0]["y"][currentMonthIndex],
                                        xref: 'x',
                                        yref: 'y',
                                        text: me.textNumbers.currentMonth+" "+me.textNumbers.previousYear,
                                        showarrow: true,
                                        arrowhead: 2,
                                        arrowcolor: '#FFFFFF',
                                        ax: -25,
                                        ay: -40
                                    },
                                    {
                                        x: customdata.data.monthly_energy_performance_by_site[pref].eiData[3]["x"][currentMonthIndex],
                                        y: customdata.data.monthly_energy_performance_by_site[pref].eiData[3]["y"][currentMonthIndex],
                                        xref: 'x',
                                        yref: 'y',
                                        text: me.textNumbers.currentMonth+" "+me.textNumbers.currentYear,
                                        showarrow: true,
                                        arrowhead: 2,
                                        arrowcolor: '#FFFFFF',
                                        ax: 25,
                                        ay: 40
                                    }
                                ],
                                margin:{
                                    t:30,
                                    b:20
                                },
                                height:360,
                                xaxis:{
                                    title:"(°C)"
                                },
                                yaxis:{
                                    title:"kWh/sq. m"
                                }

                            }
                            facilityData[facility].eu2019StackLayout={
                                title:pref+" - Electricity Usage Index Breakdown "+me.textNumbers.previousYear,

                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:-0.3,
                                    xanchor:'center'
                                },
                                margin:{
                                    t:30,
                                    b:20
                                },
                                height:360,

                                yaxis:{
                                    title:"kWh/sq. m",
                                    range:[0,30]
                                },
                                yaxis2: {
                                    title: '(°C)',
                                    overlaying: 'y',
                                    showgrid:false,
                                    range:[0,35],
                                    side: 'right'
                                },
                                barmode: 'stack'
                            }
                            facilityData[facility].eu2020StackLayout={
                                title:pref+" - Electricity Usage Index Breakdown "+me.textNumbers.currentYear,

                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:-0.3,
                                    xanchor:'center'
                                },
                                margin:{
                                    t:30,
                                    b:20
                                },
                                height:360,

                                yaxis:{
                                    title:"kWh/sq. m",
                                    range:[0,30]
                                },
                                yaxis2: {
                                    title: '(°C)',
                                    overlaying: 'y',
                                    showgrid:false,
                                    range:[0,35],
                                    side: 'right'
                                },
                                barmode: 'stack'
                            }
                            facilityData[facility].euGroupedLayout={
                                title:pref+" - Electricity Usage Index Comparison: "+me.textNumbers.currentYear+" vs "+me.textNumbers.previousYear,
                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:-0.3,
                                    xanchor:'center'
                                },
                                margin:{
                                    t:30,
                                    b:20
                                },
                                height:360,

                                yaxis:{
                                    title:"kWh/sq. m",
                                    range:[0,30]
                                },
                                yaxis2: {
                                    title: '(°C)',
                                    overlaying: 'y',
                                    showgrid:false,
                                    rangemode: 'tozero',
                                    side: 'right'
                                }

                            }
                            facilityData[facility].extraChart1Layout={
                                title:pref+" - Average Daily AC Consumption ",
                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:-0.3,
                                    xanchor:'center'
                                },
                                margin:{
                                    t:30,
                                    b:20
                                },
                                height:360,

                                yaxis:{
                                    rangemode: 'tozero',
                                },
                                yaxis2: {
                                    title: '(°C)',
                                    overlaying: 'y',
                                    showgrid:false,
                                    rangemode: 'tozero',
                                    side: 'right'
                                }
                            }
                            facilityData[facility].extraChart2Layout={
                                title:pref+" - Average AC Consumption at 00:00-06:00 ",
                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:-0.3,
                                    xanchor:'center'
                                },
                                margin:{
                                    t:30,
                                    b:20
                                },
                                height:360,

                                yaxis:{
                                    rangemode: 'tozero',
                                },
                                yaxis2: {
                                    title: '(°C)',
                                    overlaying: 'y',
                                    showgrid:false,
                                    rangemode: 'tozero',
                                    side: 'right'
                                }
                            }
                            facilityData[facility].pvChartLayout={
                                title:pref+" - PV Generation",
                                legend: {
                                    orientation: 'h',
                                    x:0.5,
                                    y:-0.3,
                                    xanchor:'center'
                                },
                                margin:{
                                    t:30, 
                                    b:20
                                },
                                height:360,

                                yaxis:{
                                    title: 'kWh',
                                    rangemode: 'tozero',
                                }
                            }

                            if (customdata.data.REChartDataYear.max_year){
                                facilityData[facility].SiteREChartLayout={
                                    title: pref +" Renewable Energy Total Generation "+ (parseInt(customdata.data.REChartDataYear.max_year)-1)+"-"+customdata.data.REChartDataYear.max_year,
                                    legend: {
                                        orientation: 'h',
                                        x:0.5,
                                        y:-0.3,
                                        xanchor:'center'
                                    },
                                    margin:{
                                        t:30, 
                                        b:20
                                    },
                                    height:360,

                                    yaxis:{
                                        title: 'kWh',
                                        rangemode: 'tozero',
                                    }
                                }
                            }

                            facilityData[facility].euGroupedData=customdata.data.monthly_energy_performance_by_site[pref].euGroupedData
                            facilityData[facility].eu2019StackData= customdata.data.monthly_energy_performance_by_site[pref].eu2019StackData
                            facilityData[facility].eu2020StackData= customdata.data.monthly_energy_performance_by_site[pref].eu2020StackData
                            facilityData[facility].euTableLayout= {
                                title: pref + " - Electricity Consumption (kWh). Aggregate year-to-date comparison : "+
                                    (customdata.data.monthly_energy_performance_by_site[pref].comparison.aggregate_ytd_comparision*100).toFixed(2)+"%",
                                height:160,margin:{t:40,b:0}
                            }
                            facilityData[facility].euTable=[{
                                type: 'table',
                                header: {
                                    values: ["","Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                                    align: "center",
                                    line: {width: 1, color: 'black'},
                                    fill: {color: "grey"},
                                    font: {family: "Arial", size: 12, color: "white"}
                                },
                                cells: {
                                    values: customdata.data.monthly_energy_performance_by_site[pref].euTableData,
                                    align: "center",
                                    line: {color: "black", width: 1},
                                    font: {family: "Arial", size: 11, color: ["black"]}
                                }
                            }]

                            if(customdata.data.extraChart1Data[pref]&&customdata.data.extraChart1Data[pref].length>0){
                                facilityData[facility].extraChart1Data=customdata.data.extraChart1Data[pref]
                            }
                            if(customdata.data.extraChart2Data[pref]&&customdata.data.extraChart2Data[pref].length>0){
                                facilityData[facility].extraChart2Data=customdata.data.extraChart2Data[pref]
                            }

                            if(customdata.data.pvChartData[pref] && customdata.data.pvChartData[pref].length>0) {
                                facilityData[facility].pvChartData=customdata.data.pvChartData[pref]
                            }

                            if(customdata.data.siteREChartData[pref] && customdata.data.siteREChartData[pref].length>0) {
                                facilityData[facility].siteREChartData=customdata.data.siteREChartData[pref]
                            }

                        }
                        me.facilityData=Object.values(facilityData)
                        me.loading=false
                    })

                })




            }
        }
    }
</script>

<style scoped>
    .hkl-report-holder{
        background-color: #424242;
    }
    .inner-text{
        margin-right: auto;
        margin-top: 55px;
        font-size: 8px;
        width: 100px;
        text-align: center;
        margin-left: auto;
    }
    .inner-text2{
        margin-right: auto;
        margin-top: 55px;
        font-size: 8px;
        width: 100px;
        text-align: center;
        margin-left: auto;
    }

    @media not print {
        .hkl-report-holder{
            width: 900px;
            margin-left: auto;
            margin-right: auto;
        }
        .hide-non-print{
            display: none !important;
        }
    }
    @media print {
        body {
             background-color: #303030 !important;
            background-image: none !important;
         }
        html {
            background-color: #303030 !important;
            background-image: none !important;
        }
        main {
            background-color: #303030 !important;
            background-image: none !important;
        }
        .page-height-test-base {
          padding:0;
          margin:0;
            background-color: green;
          height: 37.2cm;
          overflow-y: hidden;
        }
        .page-height-test {
          padding:0;
          margin:0;
            background-color: aqua;
          height: 0.01cm;
          overflow-y: hidden;
        }
        .page-height-test-too {
          padding:0;
          margin:0;
            background-color: blue;
          height: 0.01cm;
          overflow-y: hidden;
        }
        .page-height {
          padding:0;
          margin:0;
          /*height: 34.31cm;*/
          height: 37.2cm;
          width: 25.7925420561cm;
          overflow-y: hidden;
        }

        .page-two-height {
          padding:0;
          margin:0;
          /*height: 34.31cm;*/
          width: 25.7925420561cm;
          height: 74.4cm;
          width:100%;
          overflow-y: hidden;
        }

        .page-three-height {
          padding:0;
          margin:0;
          /*height: 34.31cm;*/
          width: 25.7925420561cm;
          height: 111.6cm;
          width:100%;
          overflow-y: hidden;
        }

        .page-four-height {
          padding:0;
          margin:0;
          /*height: 34.31cm;*/
          width: 25.7925420561cm;
          height: 148.8cm;
          width:100%;
          overflow-y: hidden;
        }

        .page-five-height {
          padding:0;
          margin:0;
          /*height: 34.31cm;*/
          width: 25.7925420561cm;
          height: 186cm;
          width:100%;
          overflow-y: hidden;
        }

        .hide-print{
            display: none;
        }
        .hkl-report-holder{
            /*width: 100%;*/
            width:25.7925420561cm;
            position: absolute;
            top: 0;
            left: 0;
            margin: 0;
            border: none !important;
            border-top: none !important;
            border-bottom: none !important;
            border-left: none !important;
            border-right: none !important;
            box-shadow: none !important;
            webkit-box-shadow: none !important;
        }
    }
</style>
<style>
    line.scrollbar-capture-zone{
        width:0;
        height:0;
        display: none !important;
    }
    .scrollbar-kit{
        width:0;
        height:0;
        display: none !important;
    }
    .hidden{
        display: none !important;
    }
    @media print {
        main.v-content {
            padding: 0 !important;
        }
        .modebar{
            display: none !important;
        }
    }
</style>
